module.exports = __webpack_public_path__ + "img/icon-notification.a8ce7e73.svg";